// extracted by css-extract-rspack-plugin
export default {"title":"title-CfLpBu","labelContainer":"labelContainer-UkAk19","labelColor":"labelColor-q5rcmW","valueLabel":"valueLabel-UozXQO","valueDescription":"valueDescription-G43dP0"};